/* tslint:disable */

declare var Object: any;
export interface AppSettingsInterface {
  "id"?: number;
}

export class AppSettings implements AppSettingsInterface {
  "id": number;
  constructor(data?: AppSettingsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AppSettings`.
   */
  public static getModelName() {
    return "AppSettings";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AppSettings for dynamic purposes.
  **/
  public static factory(data: AppSettingsInterface): AppSettings{
    return new AppSettings(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AppSettings',
      plural: 'AppSettings',
      path: 'AppSettings',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
